<template>
	<div class="private-order">
		<div class="private-order-layout container px-4 py-4">
			<private-order-banner />
			<private-order-catalog />
		</div>

		<main-footer />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PrivateOrderBanner from '@/components/private-orders/homepage/Banner.vue';
import PrivateOrderCatalog from '@/components/private-orders/homepage/Catalog.vue';
import MainFooter from '@/components/homepages/Footer.vue';

export default {
	components: {
		PrivateOrderCatalog,
		PrivateOrderBanner,
		MainFooter,
	},
	computed: {
		...mapGetters({
			isHasFeature: 'isHasFeature',
			isDropshipper: 'isDropshipper',
		}),
		isPrivateOrderVisible() {
			const visible = this.isHasFeature('private_order') && this.isDropshipper;
			return visible;
		},
	},
	methods: {
		...mapActions({
			setSearchBarPos: 'privateOrder/setSearchBarPos',
			setKeyword: 'privateOrder/setKeyword',
		}),
		handleScroll() {
			const yPos = window.scrollY;
			const screenWidth = window.screen.width;
			let isMoveSearchPrivateOrder = false;

			if (screenWidth >= 1200) {
				if (yPos >= 400) isMoveSearchPrivateOrder = true;
				else isMoveSearchPrivateOrder = false;
			} else if (screenWidth >= 992) {
				if (yPos >= 240) isMoveSearchPrivateOrder = true;
				else isMoveSearchPrivateOrder = false;
			} else {
				isMoveSearchPrivateOrder = false;
			}
			this.setSearchBarPos(isMoveSearchPrivateOrder);
		},
	},
	mounted() {
		if (!this.isPrivateOrderVisible) {
			this.$router.push({ name: 'home' });
		}

		this.setKeyword('');
		this.handleScroll();
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeMount() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped lang="scss">
.private-order-layout {
	position: relative;
}
</style>
